import { CompleteProfileController } from './complete-profile.controller';
import { IComponentOptions } from 'angular';

export const COMPLETE_PROFILE_COMPONENT = "completeProfileComponent";
export const completeProfileComponentOptions : IComponentOptions = {
    controller: CompleteProfileController,
    template: require("./complete-profile.html")
};


// WEBPACK FOOTER //
// ./app/complete-profile/complete-profile.component.ts